/**
 * Whose chats these are, as one string: the signed-in person and the workspace together. It keys
 * every chat query and picks the chat service (`chatClientFor`), so the two ends agree on how it is
 * written. Both IDs are TypeIDs, which never hold a slash.
 */
export const chatScope = (userId: string, workspaceId: string): string =>
  `${userId}/${workspaceId}`;

export function parseChatScope(scope: string): { userId: string; workspaceId: string } {
  const parts = scope.split("/");
  const [userId, workspaceId] = parts;
  if (parts.length !== 2 || !userId || !workspaceId) {
    throw new Error("A chat scope names a person and a workspace");
  }
  return { userId, workspaceId };
}
